import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

export default function ReportDownloadMenu({
  openDownloadMenu,
  setOpenDownloadMenu,
  downloadMenuRef,
  handleDownloadImage,
  handleDownloadCsv,
  reportField,
}) {
  const fieldMap = Object.fromEntries(
    reportField.map(({ headerName, field }) => [headerName, field])
  );
  const fields = Object.keys(fieldMap);
  const [openFieldDialog, setOpenFieldDialog] = useState(false);
  const [selectedFields, setSelectedFields] = useState(fields);

  useEffect(() => {
    if (fields.length > 0) {
      setSelectedFields(fields);
    }
  }, [reportField]);

  const toggleField = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
    );
  };

  return (
    <Menu
      open={openDownloadMenu}
      onClose={() => {
        setOpenDownloadMenu(false);
      }}
      anchorEl={downloadMenuRef.current}
      PaperProps={{
        sx: {
          backgroundColor: "var(--bg-color)",
          color: "var(--text-color)",
          border: "1px solid var(--border-line-color)",
        },
      }}
    >
      <Box
        sx={{
          p: 1,
          // width: "170px",
          alignItems: "center",
          flexDirection: "center",
        }}
      >
        {/* <Button variant="outlined" onClick={handleDownloadImage}>
          이미지 다운로드
        </Button> */}
        <Button
          variant="var(--button-color)"
          sx={{ mt: 1, border: "1px solid var(--text-color)" }}
          // onClick={handleDownloadCsv}
          onClick={() => setOpenFieldDialog(true)}
        >
          csv 다운로드
        </Button>

        <Dialog
          open={openFieldDialog}
          onClose={() => setOpenFieldDialog(false)}
        >
          <DialogTitle>다운로드할 필드 선택</DialogTitle>
          <DialogContent>
            <FormGroup>
              {reportField.map(({ headerName, field }) => (
                <FormControlLabel
                  key={field}
                  control={
                    <Checkbox
                      checked={selectedFields.includes(headerName)}
                      onChange={() => toggleField(headerName)}
                    />
                  }
                  label={headerName}
                />
              ))}
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenFieldDialog(false)}>취소</Button>
            <Button
              onClick={() => {
                setOpenDownloadMenu(false);
                setOpenFieldDialog(false);
                const mappedFields = selectedFields.map(
                  (header) => fieldMap[header]
                );
                setSelectedFields(fields);
                handleDownloadCsv(mappedFields);
              }}
            >
              다운로드
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Menu>
  );
}
